(() => {
  const initGallery = (scope = document) => {
    scope.querySelectorAll('.kitchens-page').forEach((section) => {
      if (section.dataset.kitchensGalleryReady === 'true') return;

      const lightbox = section.querySelector('[data-kitchens-lightbox]');
      const image = section.querySelector('[data-kitchens-lightbox-image]');
      const caption = section.querySelector('[data-kitchens-lightbox-caption]');
      const triggers = section.querySelectorAll('[data-kitchens-lightbox-trigger]');

      if (!lightbox || !image || !caption || !triggers.length) return;

      let activeTrigger = null;

      const closeLightbox = () => {
        lightbox.hidden = true;
        image.removeAttribute('src');
        image.alt = '';
        caption.textContent = '';
        document.body.classList.remove('kitchens-lightbox-open');
        if (activeTrigger) activeTrigger.focus();
        activeTrigger = null;
      };

      const openLightbox = (trigger) => {
        activeTrigger = trigger;
        image.src = trigger.dataset.imageSrc;
        image.alt = trigger.dataset.imageCaption || '';
        caption.textContent = trigger.dataset.imageCaption || '';
        lightbox.hidden = false;
        document.body.classList.add('kitchens-lightbox-open');
        lightbox.querySelector('.kitchens-page__lightbox-close').focus();
      };

      triggers.forEach((trigger) => trigger.addEventListener('click', () => openLightbox(trigger)));
      lightbox.querySelectorAll('[data-kitchens-lightbox-close]').forEach((close) => {
        close.addEventListener('click', closeLightbox);
      });

      section.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });

      section.dataset.kitchensGalleryReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGallery());
  } else {
    initGallery();
  }

  document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
})();
